import React from "react";
import { Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ProductListInterfaceForWriteOffPage } from "../../../../../interfaces/interfaces";
import OtherWriteOffProductsTableRow from "./OtherWriteOffProductsTableRow";
import { ProductWriteOffInput } from "@me-team/host/main/graphql/types";

type OtherWriteOffProductsProps = {
    addedProducts: ProductListInterfaceForWriteOffPage[];
    changeProductsToWriteOff: (
        productToWriteOff: ProductWriteOffInput,
        changedField: keyof ProductWriteOffInput
    ) => void;
    removeProductFromWriteOff: (productId: number, isProductFromTechMap: boolean) => void;
};

const OtherWriteOffProducts: React.FC<OtherWriteOffProductsProps> = (props) => {
    const { t: translate } = useTranslation();

    return (
        <div className={"mb-5"}>
            <h4 className={"fw-normal mb-4"}>{translate("Added Products to Write-off")}</h4>
            <Table responsive className="align-start">
                <thead className="fs-7">
                    <tr>
                        <th className="col-2 ps-4">{translate("Product name")}</th>
                        <th className="col-1"></th>
                        <th className="col-3" style={{ minWidth: "150px" }}>
                            {translate("Warehouse")}
                        </th>
                        <th className="col-2" style={{ minWidth: "100px" }}>
                            {translate("Quantity")}
                        </th>
                        <th className="col-2" style={{ minWidth: "100px" }}>
                            {translate("Measurement")}
                        </th>
                        <th className="col-1"></th>
                        <th className="col-1"></th>
                    </tr>
                </thead>
                <tbody>
                    {props.addedProducts.map((product: ProductListInterfaceForWriteOffPage) => {
                        return (
                            <OtherWriteOffProductsTableRow
                                key={product.id}
                                product={product}
                                changeProductsToWriteOff={props.changeProductsToWriteOff}
                                removeProductFromWriteOff={props.removeProductFromWriteOff}
                            />
                        );
                    })}
                </tbody>
            </Table>
        </div>
    );
};

export default React.memo(OtherWriteOffProducts);
